module.exports = __webpack_public_path__ + "img/PharaohsOfTheNile_DG.c40a85be.jpg";